import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Alert from 'react-bootstrap/Alert'
import { toast } from 'react-toastify'

import { PanelFooter, PanelHeader } from 'components/Panel'
import './home.css'

function Home(props) {

	useEffect(() => {
		toast.success('¡Bienvenido al panel de administración!')
	}, [])

	// render
	return (
		<Container fluid id="home" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} sm={6} lg={4} className="mt-2">
					<h1>Inicio</h1>
					<hr />
					<Alert>Bienvenido al panel de administración de Cifarma. A la izquierda se encuentra el menú para navegar entre las diferentes secciones y gestionar el contenido del sitio web.</Alert>
				</Col>
			</Row>
		</Container>
	);
}

export default Home